// utils/lazyLoadComponent.js
import LoadingSpinner from '../components/LoadingSpinner.vue';
import ErrorComponent from '../components/ErrorComponent.vue';

/**
 * 懒加载组件的工具函数，使用 Vue Router 推荐的方式
 * 不再使用 defineAsyncComponent，而是直接返回动态导入函数
 */
export default function lazyLoadComponent(componentPath) {
    const modules = import.meta.glob('../**/*.vue');
    const matchingPath = Object.keys(modules).find(path => path.includes(componentPath.replace('@/', '../')));
    if (!matchingPath) {
        console.error(`No matching component found for path: ${componentPath}`);
        return () => Promise.resolve(ErrorComponent);
    }
    
    // 返回一个函数，该函数返回一个 Promise，符合 Vue Router 的要求
    return () => {
        return modules[matchingPath]()
            .catch(error => {
                console.error(`Error loading component ${componentPath}:`, error);
                return Promise.resolve(ErrorComponent);
            });
    };
}
